<template>
    <ParentFormModel
        :add-action="addAction"
        :update-action="updateAction"
        :delete-action="deleteAction"
        :view-action="viewAction"
        category="FILTER"
    />
</template>

<script>
import ParentFormModel from "@/views/Notification/ControlProgram/Components/ParentFormModel.vue";

export default {
    name: "ParentControlProgramForm",
    components: {ParentFormModel},
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
    }
}
</script>

<style scoped>

</style>